/**
 * Free / disposable email domain policy — shared between client and server.
 *
 * Moved out of lib/onboardingUx.ts (Self-Serve Onboarding spec §2.1 P-9) so
 * the server can enforce the same list the client uses for its "Free email"
 * label: workspace-owner signup blocks these domains server-side
 * (POST /api/platform/signup/*), while applicant/referrer signup keeps its
 * existing label-only behavior. onboardingUx.ts re-exports these symbols so
 * existing client imports do not churn.
 */

/** Small, curated list of free/disposable email providers. */
export const DISPOSABLE_EMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'ymail.com',
  'rocketmail.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'protonmail.com',
  'proton.me',
  'tutanota.com',
  'tuta.com',
  'gmx.com',
  'gmx.net',
  'mail.com',
  'yandex.com',
  'zoho.com',
  'zohomail.com',
];

/** Lower-cased domain of an email address, or ''. */
export function emailDomain(email?: string): string {
  const e = (email || '').trim().toLowerCase();
  const at = e.lastIndexOf('@');
  return at > 0 ? e.slice(at + 1) : '';
}

/** True when the email uses a free/disposable provider. */
export function isDisposableEmail(email?: string): boolean {
  return DISPOSABLE_EMAIL_DOMAINS.includes(emailDomain(email));
}
